import {
  AUDIT_RESULTS_CLEAR,
  AUDIT_RESULTS_FETCH_COMPLETED_AUDIT_REQUEST,
  AUDIT_RESULTS_SET_APPLIED_AUDITOR_ASSET_ID,
} from '../../../../../actions/actionTypes';

const defaultState = null;

const auditorAssetId = (state = defaultState, action) => {
  switch (action.type) {
    case AUDIT_RESULTS_CLEAR:
    case AUDIT_RESULTS_FETCH_COMPLETED_AUDIT_REQUEST:
      return defaultState;

    case AUDIT_RESULTS_SET_APPLIED_AUDITOR_ASSET_ID:
      return action.payload.assetId;

    default:
      return state;
  }
};

export default auditorAssetId;
